import { Typography, IconButton } from "@mui/material";
import { Link as IconLink, Add as IconAdd } from "@mui/icons-material";
import FlexRow from "../common/FlexRow";

function StudyEmptyMessage({
  typeName,
  studyName,
  newVerb,
  iconNew = null,
  onNewClicked,
  onLinkClicked,
}) {
  return (
    <Typography variant="subtitle1">
      There are no {typeName} linked to {studyName}. To link {typeName} to this study you can:
      <div>
        <FlexRow>
          <IconButton onClick={onLinkClicked} size="large">
            <IconLink />
          </IconButton>
          <Typography style={{ marginTop: 12 }}> Link existing {typeName} </Typography>
        </FlexRow>
        <FlexRow>
          <IconButton onClick={onNewClicked} size="large">
            {iconNew ? iconNew : <IconAdd />}
          </IconButton>
          <Typography style={{ marginTop: 12 }}>
            {newVerb ? newVerb : "Add"} new {typeName}{" "}
          </Typography>
        </FlexRow>
      </div>
    </Typography>
  );
}

export default StudyEmptyMessage;
